import { useAuth0 } from '@auth0/auth0-react';
import useSWR from 'swr';

import { useAxios } from './axiosApi';

export function useUploads(userId, uploadId, daysSince, allPending, refreshInterval) {
  const { user, isAuthenticated } = useAuth0();

  const { apiGet } = useAxios();

  // If userId is not specified, use the current user.
  const userIdQuery = userId ?? user?.sub;

  let fromDate = null;
  if (daysSince) {
    fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - daysSince);
    // Round date down to nearest day to avoid unnecessary cache misses
    fromDate.setHours(0, 0, 0, 0);
  }

  const { data: uploadItems, error } = useSWR(
    isAuthenticated && userIdQuery ?
      ['/batch/upload', { params: { userId: userIdQuery, uploadId, fromDate, allPending } }]
      : null,
    async ([path, config]) => {
      const response = await apiGet(path, config);
      if (response.data?.status !== 'success') {
        throw new Error(response.data?.message);
      }
      return response.data?.data;
    },
    { refreshInterval },
  );

  const uploadsComplete = uploadItems && uploadItems.reduce((acc, cur) => {
    if (cur.status === 'complete' || cur.status === 'invalid') {
      return acc + 1;
    } else {
      return acc;
    }
  }, 0);
  const uploadsPending = uploadItems && (uploadItems.length - uploadsComplete);

  return {
    uploadItems,
    uploadsPending,
    uploadsComplete,
    error,
  }
}
